import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getRetellLecture = (params) => {
	var url = ApiRouters.RETELLLECTURE;
	return api.get(url, { params });
};

export const getRetellLectureDetail = (id, params) => {
	var url = `${ApiRouters.RETELLLECTURE}/${id}`;
	return api.get(url, { params });
};

export const createQuesRetellLecture = (body) => {
	var url = ApiRouters.RETELLLECTURE;
	return api.post(url, body);
};

export const updateRetellLectureDetail = (body) => {
	var url = `${ApiRouters.RETELLLECTURE}/${body.id}`;
	return api.put(url, body);
};

export const deleteRetellLecture = (id) => {
	var url = `${ApiRouters.RETELLLECTURE}/${id}`;
	return api.delete(url);
};
